import { TextField, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";


const SSSInquireDetails = (props) => {
	const { validTransactions, transaction, styles, classes } = props;
	const transactions = validTransactions && validTransactions.SSSNW;
	const details = Array.isArray(transactions)
		? transactions.find(
				(item) => item.account === transaction.referenceNumber
		  )
		: {
				code: "SSSNW",
				details: {
					payType: validTransactions && validTransactions.payType,
					payeeName: validTransactions && validTransactions.payeeName,
					applDtFr: validTransactions && validTransactions.applDtFr,
					applDtTo: validTransactions && validTransactions.applDtTo,
					invoiceNum: validTransactions && validTransactions.invoiceNum,
				},
		  };
	return (
		<>
            {!isEmpty(details) &&(
                <>
                    <TextField size="small" fullWidth variant="outlined" name={'name'}
                        style={{width: "200px"}}
                        InputProps={{
                            classes: {
                                input: styles.textInput,
                                root: classes.inputWithValue,
                            },
                            disabled: true
                        }}
                        label={
                            <Typography className={classes.inputLabel}>
                                Member Name
                            </Typography>
                        }
                        value={details.details.payeeName}
                    ></TextField>
                    <TextField size="small" fullWidth variant="outlined" name={'name'}
                        style={{width: "200px"}}
                        InputProps={{
                            classes: {
                                input: styles.textInput,
                                root: classes.inputWithValue,
                            },
                            disabled: true
                        }}
                        label={
                            <Typography className={classes.inputLabel}>
                                Payment Type
                            </Typography>
                        }
                        value={details.details.payType}
                    ></TextField>
                    <TextField size="small" fullWidth variant="outlined" name={'name'}
                        style={{width: "200px"}}
                        InputProps={{
                            classes: {
                                input: styles.textInput,
                                root: classes.inputWithValue,
                            },
                            disabled: true
                        }}
                        label={
                            <Typography className={classes.inputLabel}>
                                Applicable Period From
                            </Typography>
                        }
                        value={details.details.applDtFr}
                    ></TextField>
                    <TextField size="small" fullWidth variant="outlined" name={'name'}
                        style={{width: "200px"}}
                        InputProps={{
                            classes: {
                                input: styles.textInput,
                                root: classes.inputWithValue,
                            },
                            disabled: true
                        }}
                        label={
                            <Typography className={classes.inputLabel}>
                                Applicable Period To
                            </Typography>
                        }
                        value={details.details.applDtTo}
                    ></TextField>
                    <TextField size="small" fullWidth variant="outlined" name={'name'}
                        style={{width: "200px"}}
                        InputProps={{
                            classes: {
                                input: styles.textInput,
                                root: classes.inputWithValue,
                            },
                            disabled: true
                        }}
                        label={
                            <Typography className={classes.inputLabel}>
                                Invoice Number
                            </Typography>
                        }
                        value={details.details.invoiceNum}
                    ></TextField>
                </>
            )}
        </>
	);
};

export default SSSInquireDetails;